// 交易看板统计信息组件
export default {
  // 转入部分
  transferIn: "转入",
  earliestTransferIn: "最早转入：",

  // 转出部分
  transferOut: "转出",
  latestTransferOut: "最近转出：",

  // 统计标签
  transactionCount: "交易次数",
  transactionAmount: "交易数量",
  counterparties: "交易对手",

  // 单位
  times: "次",
  tenThousand: "万",
  units: "个",
};
